import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import moment from "moment";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import InputFieldText from "Components/Common/InputFieldText";
import SelectField from "Components/Common/SelectField";
import DateField from "Components/Common/DatePicker";
import { applicationTypes } from "common/constant";

import { onlyNumberKeys } from "utils";

import { useGetSourceOfPowersQuery } from "apis/TechnicalSanction";

const UtilityConsumerDetails = ({ formik, isPowerUtilityConsumer, t }) => {
  const {
    values: { dateOfConnection, applicationType },
  } = formik;

  const { data: { data: sourceOfPowerOptions } = {} } =
    useGetSourceOfPowersQuery();

  const maxDateDProp = useMemo(
    () =>
      applicationType === applicationTypes["Temporary Connection"] &&
      dateOfConnection
        ? {
            maxDate: moment(dateOfConnection)
              .add(1, "years")
              .subtract(1, "days"),
          }
        : {},
    [applicationType, dateOfConnection]
  );

  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Consumer Number") + "*"}
          name="consumerNumber"
          formik={formik}
          InputProps={{
            inputProps: { min: 0, onKeyDown: (e) => onlyNumberKeys(e) },
          }}
          placeholder="Enter Consumer Number"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFieldText
          label={t("Consumer Name") + "*"}
          name="consumerName"
          formik={formik}
          placeholder="Enter Consumer Name"
        />
      </Grid>
      {isPowerUtilityConsumer && (
        <>
          <Grid item xs={12} sm={4}>
            <SelectField
              label={t("Source Of Power") + "*"}
              name="sourceOfPowerId"
              formik={formik}
              options={sourceOfPowerOptions || []}
              getOptionLabel={({ name }) => name}
              getOptionValue={({ id }) => id}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFieldText
              label={t("Electricity Duty") + "*"}
              name="electricityDuty"
              type="number"
              formik={formik}
              InputProps={{
                inputProps: {
                  min: 0,
                  onKeyDown: (e) => onlyNumberKeys(e, true),
                },
              }}
              placeholder="Enter Electricity Duty"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFieldText
              label={t("Security Deposit") + "*"}
              name="securityDeposit"
              type="number"
              formik={formik}
              InputProps={{
                inputProps: {
                  min: 0,
                  onKeyDown: (e) => onlyNumberKeys(e, true),
                },
              }}
              placeholder="Enter Security Deposit"
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} sm={4}>
        <DateField
          label={t("Connection Date")}
          name="dateOfConnection"
          formik={formik}
          format="DD-MM-YYYY"
          placeholder="Select Connection Date"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DateField
          label={t("Disconnection Date")}
          name="disconnectionDate"
          formik={formik}
          format="DD-MM-YYYY"
          placeholder="Select Disconnection Date"
          disablePast
          {...maxDateDProp}
        />
      </Grid>
    </Grid>
  );
};

UtilityConsumerDetails.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
  isPowerUtilityConsumer: PropTypes.bool,
};

export default withTranslation()(UtilityConsumerDetails);
